<div id="subscriptionSingleFeePrint" style="display: none">
  <div class="invoice-box" style="padding: 0px !important; width: 75mm; max-width: 75mm; margin: 0 !important;">
    <div style="width: 75mm; max-width: 75mm; margin-top: 30px; margin-bottom: 30px">
      <div style="display: flex; justify-content: center; align-items: center;">
        <ng-container *ngIf="invoiceData.bannerImage.length === 1">
          <img [src]="config.Server + 'assets/layout/images/companies/' + invoiceData.bannerImage[0]?.image"
            alt="Company Logo" style="
            display: block;
            margin-left: auto;
            margin-right: auto;
            width: 58%;
            margin-top: 3px;
            margin-bottom: 2px;
            max-height: 150px;"
          />
        </ng-container>
        <ng-container *ngIf="invoiceData.bannerImage.length > 1">
          <img *ngFor="let banner of invoiceData.bannerImage"
            [src]="config.Server + 'assets/layout/images/companies/' + banner.image"
            alt="Company Logo" style="
            display: block;
            margin-left: auto;
            margin-right: auto;
            width: 58%;
            margin-top: 3px;
            margin-bottom: 2px;
            max-height: 150px;"
          />
        </ng-container>
      </div>
      <div style="text-align: center; font-size: 11px; line-height: 14px; color: black;">
        {{ invoiceData.name }}
      </div>
      <div style="text-align: center; font-size: 11px; line-height: 14px; color: black;">
        {{ invoiceData.address }}
      </div>
      <div *ngIf="invoiceData.contact.length === 1" style="text-align: center; font-size: 11px; line-height: 15px; color: black;">
        {{ invoiceData.contact[0].contactNumber }}
    </div>
    <div *ngIf="invoiceData.contact.length > 1" style="text-align: center; font-size: 11px; line-height: 15px; color: black;">
        <div *ngFor="let contact of invoiceData.contact" >
            {{ contact.contactNumber }}
        </div>
    </div>
      <table style="border-collapse: collapse; border: 1px solid black; font-size: 9px; line-height: 12px; margin-top: 8px; margin-left: 8px; width: 95%;">
        <tbody>
          <tr>
            <td style="font-size: 10px; text-align:center; padding: 0px; font-weight: bold;" colspan="2">
              {{ fee.invoice }}
            </td>
            <td style="font-size: 10px; text-align: center; padding: 0px; font-weight: bold;">
              Created:
            </td>
            <td style="font-size: 10px; text-align: center; padding: 0px;">
              {{ fee.createdDate | date : "dd/MM/yyyy" }}
            </td>
          </tr>
          <!-- <tr>
            <td style="font-size: 10px; text-align: center; padding: 0px; font-weight: bold;">
              Due Date:
            </td>
            <td style="font-size: 10px; text-align: center; padding: 0px;">
              {{ fee.startDate | date : "dd/MM/yyyy"}}
            </td>
            <td style="font-size: 10px; text-align: center; padding: 0px; font-weight: bold;">
              Next Due:
            </td>
            <td style="font-size: 10px; text-align: center; padding: 0px;">
              {{ fee.endDate | date : "dd/MM/yyyy"}}
            </td>
          </tr> -->
        </tbody>
      </table>
      <table style="border-collapse: collapse; font-size: 12px; font-size: 9px; margin-top: 3px; line-height: normal; width: 95%; margin-left: 8px;">
        <thead style="border: 1px solid black; text-align: center; font-weight: bold; font-size: 12px; font-size: 9px; background-color: black; color: white; border: 1px solid black;">
          <tr style="background-color: black; color: white">
            <th style="width: 40px; word-break: break-word; font-size: 10px;">
              {{setLabel("m#Label")}}
            </th>
            <th style="width: 40px; word-break: break-word; font-size: 10px;">
              {{setLabel("nameLabel")}}
            </th>
            <th style="width: 40px; word-break: break-word; font-size: 10px;">
              {{setLabel("typeLabel")}}
            </th>
            <th style="width: 40px; font-size: 9px">{{setLabel("amountLabel")}}</th>
            <th style="width: 40px; font-size: 9px">{{setLabel("discountLabel")}}</th>
            <th style="width: 40px; font-size: 9px" *ngIf="fee.taxCalculationType !== 'NO_TAX'">
              {{setLabel("taxLabel")}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="font-size: 9px; border: 1px solid black; text-align: center;">
              {{ fee.membershipNumber }}
            </td>
            <td style="font-size: 9px; border: 1px solid black; text-align: center;">
              {{ fee.memberName }}
            </td>
            <td style="font-size: 9px; border: 1px solid black; text-align: center;">
              {{ fee.feeType }}
            </td>
            <td style="font-size: 9px; border: 1px solid black; text-align: center;">
              {{ (fee.fee) | number: '1.0-0' }}
            </td>
              <td style="font-size: 9px; border: 1px solid black; text-align: center;">
                {{ fee.discount | number: '1.0-0' }}
              </td>
            <td style="font-size: 9px; border: 1px solid black; text-align: center;" *ngIf="fee.taxCalculationType !== 'NO_TAX'">
              {{(fee.tax !== undefined ? fee.tax : 0) | number: '1.0-0'  }}
            </td>
          </tr>
          <tr>
            <td></td>
            <td style="font-size: 10px; text-align: center; font-weight: bold; border-bottom: 1px solid; border-left: 1px solid;" colspan="2">
              {{setLabel("subTotalLabel")}}
            </td>
            <td style="font-size: 10px; text-align: center; border-right: 1px solid; border-bottom: 1px solid;" colspan="3">
              <span>
                {{ (calculateTotalForSinglePrint(fee.fee, fee.tax, fee.discount,fee.taxCalculationType)) | number:'1.0-0'}}
              </span>
              <i *ngIf="fee.taxCalculationType === 'INCLUDING_TAX'" style="display: block; font-size: 8px;">
                {{fee.tax}} Tax is included in the fee.
              </i>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="text-align: center; padding-top: 6px; font-size: 10px; font-weight: bold; color: black; white-space: nowrap;">
        {{setLabel("softwareProvidedByTecfolkLabel")}}
      </div>
    </div>
  </div>
</div>